import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import RightSvg from '../components/icons/RightSvg'
import header_image from '../images/mainpage-header.webp'
import Card1 from '../components/cards/Card1'
import AboutMP from '../components/sections/AboutMP'
import ServicesMP from '../components/sections/ServicesMP'
import ProjectMP from '../components/sections/ProjectMP'
import WhyUsMp from '../components/sections/WhyUsMp'
import BlogsMP from '../components/sections/BlogsMP'
import CodeSvg from '../components/icons/CodeSvg'
import { Helmet } from 'react-helmet'

export class MainPage extends Component {
    render() {
        return (
            <main>

                <Helmet>
                    {/* Meta Title */}
                    <title>ITnova - İT, Veb Dizayn, Mobil Tətbiq, SEO və Robototexnika üzrə Lider</title>

                    {/* Meta Description */}
                    <meta name="description" content="ITnova Azərbaycanın aparıcı texnologiya şirkətidir, İT xidmətləri, innovativ veb dizayn, mobil tətbiq hazırlığı, SEO və robototexnika həllərində ixtisaslaşmışdır. Biznesinizi qabaqcıl texnologiya və dizaynla inkişaf etdirmək üçün itnova.az saytına daxil olun." />

                    {/* Meta Keywords */}
                    <meta name="keywords" content="ITnova, İT xidmətləri, veb dizayn, mobil tətbiq hazırlığı, SEO, robototexnika, innovasiya, texnologiya, itnova.az, sayt dizaynı, texnoloji həllər, Azərbaycan, İT şirkəti" />

                    {/* Open Graph Meta Tags (for social sharing) */}
                    <meta property="og:title" content="ITnova - İT, Veb Dizayn, Mobil Tətbiq, SEO və Robototexnika üzrə Lider" />
                    <meta property="og:description" content="ITnova, İT xidmətləri, innovativ dizayn, mobil tətbiq hazırlığı və robototexnika həlləri təqdim edir. Bizim peşəkar SEO strategiyaları ilə biznesinizi inkişaf etdirin." />
                    <meta property="og:url" content="https://itnova.az" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://itnova.az/static/media/logo.76d56b1f9b610982be1a.png" />
                </Helmet>

                {/* <header className='header-bg-image'>
                    <div className='container flex justify-between items-center'>

                        <div>
                            <h1>
                                Biznesinizi rəqəmsal dünyada Celt Tech ilə inkişaf eletdirin
                            </h1>

                            <Link>
                                <button className='bg-[#0E38B1] text-[#fff] text-[18px] font-[500] p-[14px_16px] rounded-[8px] flex items-center gap-[8px]'>
                                    Təklif al

                                    <RightSvg />
                                </button>
                            </Link>
                        </div>

                        <div className='relative w-[600px] h-[600px] mt-[40px] '>
                            <img src={office_bg} className='office_bg max-w-[488px] max-h-[488px]' />
                            <img src={header_boy} className='header_boy max-w-[595px] max-h-[585px]' />
                        </div>

                    </div>


                </header> */}

                <header className=' bg-[#f4f8fc]'>
                    <div className='container flex items-center h-[80vh] max-[1001px]:flex-col max-[1001px]:pt-[20px] max-[1001px]:gap-[12px] max-[440px]:h-[65vh]  max-[440px]:gap-[16px] max-[400px]:h-[60vh] max-[320px]:h-[55vh]   '>
                        <div className=' flex flex-col gap-[28px] max-w-[50%] max-[1001px]:items-center max-[1001px]:gap-[10px]'>
                            <div className='max-[1001px]:flex max-[1001px]:flex-col max-[1001px]:gap-[4px]'>
                                <h1 className='text-[50px] font-[700] max-[1200px]:text-[40px] max-[1001px]:text-[30px] max-[1001px]:text-center max-[1001px]:font-[600] max-[400px]:text-[22px] max-[400px]:max-w-[300px] max-[320px]:max-w-[280px] max-[320px]:text-[18px]' >
                                    Biz Sizin İşinizi Rəqəmsal Dünyaya Daşıyırıq
                                </h1>
                                <p className='text-[#676879] text-[18px] font-[300] max-[1200px]:text-[17px] max-[1001px]:text-[15px] max-[1001px]:text-center max-[750px]:max-w-[500px] max-[440px]:w-[380px] max-[400px]:text-[14px] max-[400px]:max-w-[300px] max-[320px]:max-w-[280px] max-[320px]:text-[12px]  '>
                                    Veb sayt dizaynı, kodlaşdırılması, mobil tətbiqlərin hazırlanması və SEO xidmətləri ilə rəqəmsal işinizi daha irəliyə aparın.
                                </p>
                            </div>

                            <Link to="/contact-us" >
                                <button className='bg-[#0E38B1] text-[#fff] text-[18px] font-[500] p-[14px_16px] rounded-[8px] flex items-center gap-[8px] max-[1001px]:p-[10px_12px] max-[1001px]:text-[16px] max-[350px]:text-[14px] max-[350px]:p-[7px_9px]'>
                                    Bizimlə əlaqə yaradın
                                    <RightSvg fill="#fff" height="20" width="20" />
                                </button>
                            </Link>


                        </div>

                        <div className=''>
                            <img src={header_image} className='max-w-1/2 max-h-[450px] max-[1001px]:max-h-[350px] ' />
                        </div>
                    </div>
                </header>





                <AboutMP />

                <ServicesMP
                    className="bg-[#f4f8fc]"
                />

                <WhyUsMp />

                <section className=' max-[1101px]:p-[0px_40px] mt-[32px] mb-[52px] max-[720px]:m-[0px_0px]'>
                    <div className='container shadow-lg rounded-[8px] grid grid-cols-4 gap-[16px] bg-[#ffffff] p-[30px_45px] max-[1050px]:grid-cols-2  max-[720px]:grid-cols-1 '>
                        <Card1
                            number="30"
                            title="Veb sayt"
                            className="max-[1050px]:p-[0px_50px] max-[720px]:p-[0px_0px]"
                        />
                        <Card1
                            number="35"
                            title="Dizayn"
                        />
                        <Card1
                            number="12"
                            title="Mobil tətbiq"
                            className="max-[1050px]:p-[0px_50px] max-[720px]:p-[0px_0px]"
                        />
                        <Card1
                            number="3"
                            title="Robot texnika"
                        />
                    </div>
                </section>

                {/* <ProjectMP
                    className="bg-[#f4f8fc]"
                /> */}

                {/* <BlogsMP
                    section_head="Rəqəmsal Dünyadakı Son Yeniliklər"
                    section_title="Bloq"

                /> */}

            </main>
        )
    }
}

export default MainPage